import { createSlice } from "@reduxjs/toolkit";
import { subDays } from "date-fns";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  startDate: subDays(new Date(), 30),
  endDate: new Date(),
  userFeedbackExcelSendModal: false,
  storeId: "",
  starId: "",
  totalCount: "",
};

const userFeedbackSlice = createSlice({
  name: "userFeedback",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});
export const { updateConfig } = userFeedbackSlice.actions;
export default userFeedbackSlice.reducer;
